// Smooth-scroll to a section with a stable header offset.
// IMPORTANT: use a constant offset (NOT header.offsetHeight) — on mobile the
// open burger menu lives inside the header and would inflate offsetHeight,
// causing the page to under-scroll ("buttons not working").
export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const headerOffset = 80;
  const go = () => {
    const top = el.getBoundingClientRect().top + window.scrollY - headerOffset;
    window.scrollTo({ top: Math.max(top, 0), behavior: "smooth" });
  };
  go();
  // Correct for late layout shifts (lazy-loaded images/videos) once settled.
  setTimeout(() => {
    const top = el.getBoundingClientRect().top + window.scrollY - headerOffset;
    if (Math.abs(top - window.scrollY) > 6) {
      window.scrollTo({ top: Math.max(top, 0), behavior: "smooth" });
    }
  }, 700);
};
